export default "__VITE_ASSET__CI4m6e8h__"